import {rolePrefix, TSRole} from './enums/TSRole';
import {TSSerializable} from './TSSerializable';
import TSAbstractEntity from './TSAbstractEntity';

/**
 * Entspricht ungefaehr den Felder die ueber JaxAuthAccessElement in das Cookie gesetzt werden
 */
export default class TSUser extends TSAbstractEntity implements TSSerializable<TSUser> {
    private _nachname?: string;
    private _vorname?: string;
    private _password?: string;
    private _email?: string;
    private _roles: Array<TSRole> = [];

    constructor(vorname?: string, nachname?: string, password?: string, email?: string,
                role?: Array<TSRole>) {
        super();
        this._vorname = vorname;
        this._nachname = nachname;
        this._password = password;
        this._email = email;
        if (role !== undefined) {
            this._roles = role;
        } else {
            this._roles = [];
        }

    }

    public get nachname() {
        return this._nachname;
    }

    public set nachname(value: string | undefined) {
        this._nachname = value;
    }

    public get vorname(): string | undefined {
        return this._vorname;
    }

    public set vorname(value: string | undefined) {
        this._vorname = value;
    }

    public get password(): string | undefined {
        return this._password;
    }

    public set password(value: string | undefined) {
        this._password = value;
    }

    public get email(): string | undefined {
        return this._email;
    }

    public set email(value: string | undefined) {
        this._email = value;
    }

    public get roles(): Array<TSRole> {
        return this._roles;
    }

    public set roles(value: Array<TSRole>) {
        this._roles = value;
    }

    public getFullName(): string {
        return (this.vorname ? this.vorname : '') + ' ' + (this.nachname ? this.nachname : '');
    }

    getRoleKey(): string {
        return rolePrefix() + this.roles;
    }

    public deserialize(restObject: any): TSUser {
        super.deserialize(restObject);
        this._vorname = restObject.vorname;
        this._nachname = restObject.nachname;
        this._password = restObject.password;
        this._email = restObject.email;
        this._roles = restObject.roles;

        return this;
    }

    public serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.vorname = this.vorname;
        restObject.nachname = this.nachname;
        restObject.password = this.password;
        restObject.email = this.email;
        restObject.roles = this.roles;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSUser.ts